import React from 'react';

/** Route placeholder — iframe is hosted by DataValidationFrameHost (stays mounted across navigation). */
const DataValidationPage: React.FC = () => {
    return (
        <div
            aria-hidden="true"
            style={{ minHeight: 'calc(100vh - 140px)' }}
        />
    );
};

export default DataValidationPage;
